/**
 * @file   src\mobile\components\createWantAd\Layout.js
 * @brief  This file is responsible for nice to haves section subcomponent
 * @date   April, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */
import React from "react";
import NiceToHaveHelper from "./NiceToHaveHelper";

const Layout = (props) => {
  const { layout, handleItemClick, itemArray } = props;
  return (
    <NiceToHaveHelper
      list={layout}
      selectedItems={itemArray}
      propertyClick={handleItemClick}
    />
  );
};
export default Layout;
